import type { IETFLanguageTag } from '../IETFLanguageTag'

const localized: Map<IETFLanguageTag, string> = new Map()
/**
 * GMT isn’t abbreviated as ‘GMT’ in all locales--for example, in `ar-EG` it’s
 * “غرينتش”.
 */
export function gmtInLocale(locale: IETFLanguageTag) {
  if (localized.has(locale)) return localized.get(locale)

  const formatter = new Intl.DateTimeFormat(locale, {
    timeZone: 'Etc/GMT',
    timeZoneName: 'shortOffset',
  })
  const parts = formatter.formatToParts(new Date())
  const gmt = parts.find(({ type }) => type === 'timeZoneName')?.value
  if (gmt) localized.set(locale, gmt)

  return gmt
}
